<app-filter-results
  [filterBy]="filterBy"
  [filterIn]="filterIn"
  [searchBy]="searchBy"
  [isFilterInAvailable]="true"
  [isSearchingAvailable]="true"
  (onApplyFilter)="applyFilter($event)"
  (resetFilters)="onResetFilters()"
  [filterOpen]="filterStatusParent"
  (closeNavEvent)="closeEvent($event)"
>
</app-filter-results>
